import { FC } from "react";
import { Icon, IconProps } from "../../../icons/components/Icon";
import { useTheme } from "../../../styles/theme";

export const RequisitionStatusClosedIcon: FC<IconProps> = (props) => {
  const theme = useTheme();
  return (
    <Icon height="24px" {...props} viewBox="0 0 33 33">
      <circle
        opacity="0.1"
        cx="16.5"
        cy="16.5"
        r="16.5"
        fill={theme.colors.grey}
      />
      <path
        d="M16.6562 7C11.3569 7 7 11.3503 7 16.6562C7 22.0774 11.4527 26.3125 16.6562 26.3125C21.9818 26.3125 26.3125 21.9806 26.3125 16.6562C26.3125 11.3319 21.9818 7 16.6562 7ZM15.4492 20.7771L12.1818 17.5097L13.8886 15.8029L15.4492 17.3635L19.424 13.3887L21.1308 15.0956L15.4492 20.7771Z"
        fill={theme.colors.blue}
      />
    </Icon>
  );
};
